<template>
  <el-form label-position="left" label-width="0px" class="login-container">
    <div class="express-form-wrap">
        <h3 class="guild-name">
            <span class="title">公会名：{{clubName}}</span>
        </h3>
        <div class="form-wrap" v-if="!success">
            <div v-if="clubSharedRatio.length > 0">
                <div class="info-wrap mr-20" v-if="nickname">
                    <div class="anchor-info">
                        <img class="avatar" :src="`https:${icon}`" alt="主播头像">
                        <div class="anchor-room">
                            <div class="name">
                                <span class="lable">昵称：</span>{{nickname}}
                            </div>
                            <div class="tips">
                                <div class="tips-title" v-if="roomid <= 0">您还不是主播~</div>
                                <div class="tips-title2" v-else>房间号: {{roomid}}</div>
                                <div class="tips-txt">请确保提交申请后24小时完成实名认证，否则申请无效</div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="info-wrap">
                    <div class="sign-info">
                        <h2 class="sign-info-title">您确定与该公会签约吗？</h2>
                        <div class="guild-sign">
                            <img class="guild-avatar" :src="guild_badge_image" alt="公会头像">
                            <div class="guild-sign-info">
                                <table>
                                    <tbody><tr class="sign-info-row">
                                        <td class="opt-name">签约公会：</td>
                                        <td class="opt-desc"><span class="sign-guild-name" :title="guild_name">{{guild_name}}</span></td>
                                    </tr>
                                    <tr class="sign-info-row">
                                        <td class="opt-name">签约时长：</td>
                                        <td class="opt-desc">
                                            <el-select v-model="selectIndex">
                                                <el-option v-for="(item, index) in clubSharedRatio" :key="index" :label="item.desc" :value="index"></el-option>
                                            </el-select>
                                        </td>
                                    </tr>
                                    <tr class="sign-info-row">
                                        <td class="opt-name">主播礼物提成：</td>
                                        <td class="opt-desc"><span class="ratio" id="anchor-ratio">{{100 - clubSharedRatio[selectIndex].ratio}}%</span></td>
                                        <td class="opt-name">礼物收益结算：</td>
                                        <td class="opt-desc">{{settle_type === 1 ? "对公结算" : '对私结算'}}</td>
                                    </tr>
                                    <tr class="sign-info-row">
                                        <td class="opt-name">主播陪玩提成：</td>
                                        <td class="opt-desc"><span class="ratio" id="anchor-pw-ratio">{{100 - clubSharedRatio[selectIndex].pwRatio}}%</span></td>
                                        <td class="opt-name">陪玩订单结算：</td>
                                        <td class="opt-desc">{{settle_type_pw === 1 ? "对公结算" : '对私结算'}}</td>
                                    </tr>
                                </tbody></table>
                            </div>
                            
                        </div>
                        <div class="guild-desc">
                            <p class="guild-desc-row">
                                <span class="desc-name">对公结算：</span>
                                <span class="desc-remark">主播收益在结算时，全部计入签约公会的对公账户，由公会统一代为扣税后再分配给主播。</span>
                            </p>
                            <p class="guild-desc-row">
                                <span class="desc-name">对私结算：</span>
                                <span class="desc-remark">主播收益在结算时，按公会抽成比例分别计算主播和公会所得，主播所得计入主播的个人账户，提现时将扣除相关费用。</span>
                            </p>
                            <p class="guild-desc-row">
                                <span class="desc-name attention">注意：</span>
                                <span class="desc-remark">与公会签约期间，严禁您使用其他帐号进行表演。一旦发现，官方有权禁止此帐号在斗鱼平台进行表演。</span>
                            </p>
                        </div>
                    </div>
                </div>
            </div>
            
            <div class="rowwrap">
                <el-form-item style="width: 400px; margin-left: 40px">
					<el-input v-model="mobile" placeholder="请输入手机号码" @input="onChanged" clearable @clear="this.mobile = ''">

                    </el-input>
				</el-form-item>
                <el-form-item style="width: 400px; margin-left: 40px">
					<el-input v-model.number="code" oninput="if(value.length > 6) value = value.slice(0, 6)" placeholder="请输入验证码">
                        <template slot="append" >
                            <el-button style="width: 102px" :class="isMobile ? 'enableButton' : 'disableButton'" :disabled="!isMobile || this.timeHandler > 0" @click="handleGetCode">{{this.timeHandler > 0 ? this.countDown : '获取验证码'}}</el-button>
                        </template>
                    </el-input>
				</el-form-item>
            </div>
            <div class="rowwrap protocal-wrap">
                <el-checkbox v-model="checked" style="margin-right: 2px"></el-checkbox>
                <label for="protocol" id="protocal-label">
                    <p class="protocal-text"><span>我已阅读且同意</span><a href="//www.douyu.com/protocal/roomclub" target="_blank">斗鱼公会主播入驻服务协议</a>、<a href="//www.douyu.com/cms/zhibo/201907/30/6261.shtml" target="_blank">公会主播疑难解答</a></p>
                </label>
            </div>
            <div class="rowwrap foot-wrap">
                <el-button :class="!checked || `${code}`.length < 6 || loading || !send_sms ? 'disableButton' : 'enableButton'" :loading="loading" :disabled="!checked || `${code}`.length < 6 || loading || !send_sms" style="width: 420px; height: 40px;" @click="joinClub">加入公会</el-button>
            </div>
        </div>
        <div class="foot-tips">温馨提示：请确保在提交申请后24小时内完成实名认证，否则申请无效</div>
    </div>
  </el-form>
</template>

<script>
  import { getClubNameByCode, getGuildInviteInfoByPhone, getGuildInviteGeeStatus, sendGuildInviteCode, validateGuildInviteCode } from '../api/api';
  import geetest from '../components/gt'
  import util from '../common/js/util';

  export default {
    data() {
      return {
        loading: false,
        checked: false,
        aid: this.$route.query.a,
        clubMask: this.$route.query.c,
        clubName: '',
        mobile:  '',
        isMobile: false,
        code: '',
        guild_badge_image: '',
        guild_name: '',
        isOfficial: 0,
        need_confirm: 0,
        settle_type: '',
        settle_type_pw: '',
        clubSharedRatio: [],
        selectIndex: 1,
        verified: false,
        timeHandler: 0,
        countDown: 60,
        icon: '',
        is_new: 0,
        nickname: '',
        roomid: 0,
        send_sms: false,
        success: false,
      };
    },
    methods: {
      async getClubName() {
          const res = await getClubNameByCode({ clubMask: this.clubMask, aid: this.aid })
          if (res.status === 200) {
              this.clubName = res.data.data;
          }
          if (!this.clubName) {
            //   window.location.href = 'http://s.douyu.com/BDjs0'
          }
      },
      async onChanged (val) {
          this.isMobile = util.isMobile(val);
          if (this.isMobile && this.clubSharedRatio.length === 0) {
            const res = await getGuildInviteInfoByPhone({ clubMask: this.clubMask, mobile: this.mobile })
            if (res.data.status === 200 && res.data.data.code === 0) {
                const data = res.data.data.data;
                this.guild_badge_image = data.guild_badge_image;
                this.guild_name = data.guild_name;
                this.isOfficial = data.isOfficial;
                this.need_confirm = data.need_confirm;
                this.settle_type = data.settle_type;
                this.settle_type_pw = data.settle_type_pw;
                this.clubSharedRatio = [];
                const keys = Object.keys(data.clubSharedRatio);
                keys.forEach((key) => {
                    const value = data.clubSharedRatio[key];
                    this.clubSharedRatio.push({ key, desc: value.desc, ratio: value.ratio, pwRatio: value.pwRatio})
                });
                this.clubSharedRatio.reverse();
            }
          }
      },
      handleGetCode() {
          this.captchaObj.verify();
      },
      async joinClub() {
          let message = '提交失败，请重试';
          try {
              this.loading = true;
              const res = await validateGuildInviteCode({ aid: this.aid, nickName: this.nickname, roomId: this.roomid, mobile: this.mobile, clubMask: this.clubMask, code: `${this.code}`.slice(0, 6), period: this.clubSharedRatio[this.selectIndex].key });
              this.loading = false;
              if (res.data.status === 200 && res.data.data.code === 0) {
                // 检测成功，去认证
                this.$message({
                    message: "提交成功，请尽快完成认证",
                    type: 'success'
                });
                this.success = true;
                return;
              } else if (res.data.status === 200 && res.data.data.code > 0) {
                  message = res.data.data.msg
              }
          } catch (e) {
              console.log(e);
              this.loading = false;
          }
          this.$message({
            message,
            type: 'success'
          });
      },
      async sendCode(challenge, validate, secCode) {
          const res = await sendGuildInviteCode({ mobile: this.mobile, challenge, validate, secCode });
          if (res.data.status === 200 && res.data.data.code === 0) {
              const data = res.data.data.data;
              this.icon = data.icon;
              this.is_new = data.is_new;
              this.nickname = data.nickname;
              this.roomid = data.roomid;
              this.send_sms = data.send_sms;
              if (this.send_sms) {
                  this.timeHandler = 0;
                  clearInterval(this.timeHandler);
                  this.countDown = 60;
                  this.timeHandler = setInterval(() => {
                    this.countDown--;
                    if (this.countDown === 0) {
                        this.countDown = 60;
                        clearInterval(this.timeHandler);
                        this.timeHandler = 0;
                    }
                  }, 1000);
                  return;
              }
          }
          this.$message({
            message: "验证码发送失败",
            type: 'warning'
          });
      },
      initGeetestByParam: async function() {
        const res = await getGuildInviteGeeStatus();
        if (res.data.status === 200 && res.data.data.code === 0) {
            const { gt, challenge, success } = res.data.data.data;
            initGeetest({ 
                gt, 
                challenge, 
                offline: !success, 
                new_captcha: true,
                product: "bind",
                width: "300px",
            }, (captchaObj) => {
                this.captchaObj = captchaObj;
                captchaObj.onReady(() => {
                    // 初始化完成，可以执行某些初始化函数
                }).onSuccess(() => {
                    this.verified = true;
                    let res = this.captchaObj.getValidate();
                    if (!res) {
                        return;
                    }
                    const { geetest_challenge: challenge, geetest_validate: validate, geetest_seccode: secCode } = res;
                    this.sendCode(challenge, validate, secCode);
                }).onError(() => {
                    this.verified = false;
                });
            });
        }
      },
    },
	mounted() {
      this.initGeetestByParam();
      this.getClubName();
      document.title = '欢迎加入';
    },
  }

</script>

<style lang="scss" scoped>
  .login-container {
    background: #ffda8e url(https://shark2.douyucdn.cn/front-publish/agent-front-master/assets/images/bg_66cfcea.jpg) no-repeat top;
    width: 100%;
    .express-form-wrap{
        position: relative;
        width: 497px;
        padding-top: 443px;
        margin: 0 auto;
        width: auto;
        text-align: center;
        .guild-name {
            .title {
                display: inline-block;
                max-width: 300px;
                vertical-align: middle;
                font-size: 25px;
                color: #8c5700;
            }
        }
       .guild-name::before {
            content: "";
            display: inline-block;
            vertical-align: middle;
            width: 88px;
            height: 38px;
            background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADoAAAAmCAYAAACVr4jIAAAB/klEQVRogeXYT4iNURjH8c+duSuyEyVrDTOzMbIRQykKC5RESjajRNkPC0a2k2JBTZSxs5I/hQU7SYkNS3+ymCi3lIUyFudqzr295zU1d6bO8atbz3vO795zvud97nvO+zSmx+Su1biPdTiNW1WmvqWc0SLpBEawAhdSphJAX0fx25SpuQQTWWw9xHYM4HbKVAIoPGt/kiohdeelkkAbdZ2lgPZh9F+GEjSMXXWGUkD3YEedoRTQg9iEVSlDCaAj2Ih+HEqZSgA9G8XHUqbcQYdwOLrejC1VxpxBm7gppGysyyr21JxBx4X/Z7e2Cm80HcoV9DjO1/Rf0bUITTzu4QRmcLQd97cnM4SL5l6n9uHMAsZoYpv6I98yPBK2ned/v7RzAYN262MUHzG36huwvh2v7fGYKa3EU1zHtVxTd776Jiz+jyae9PCHZ6L4jlDHGcRE1P65B2MOCJlRp2mcQgsamRbH1uCFNOwEzsUNuabuFxzAr4q+uyqeyLmCwktMdrW1cBKz3eacQeESvkfXk/haZcwdtIWr7fg3plLG3EHhhgD5Ruc+3qESyp0fhNNPsnhNGaBwDz/rDCWkLjzApzpDKXf0vf+krjuLd3WGUkCpOCTEKgm0VqWAjmIMy1OGEh5Ge4XtBfZjd5WphDs6HMWDKVMJoFN4JRzux1OmP54ySaOiQi4FAAAAAElFTkSuQmCC) no-repeat 0;
        }
        .guild-name::after {
            content: "";
            background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADoAAAAmCAYAAACVr4jIAAACKUlEQVRogd3Zv2uTQRzH8VfSTIqro7OgDloXUVQEURAXERUqKB2sOLr6o1Bd3LQiVNA6SJ3URf8BoZsIKgpRLGIJgqCgopM/h0slick9gfQeen1D4Jt77sl9Ptz3ufs+l8rMmF4cw1W8xj586NkzA6qRaxewCsMYLUdOOmJGn7fET1MLSU0tcu0wjqKOR+XISUfM6HdcL0tIamKpu6woMlopRUUJFBnd0UefLCgysQfryxCSmthiBLvwVftWkyWxGV0tFAsHS9KSlJjRQxjCpuYna2JGj7fEpxPrSE4vo7uFtF3giMwXpW5GKxjvaBvCLcWL15Klm9FRbO3Svhln08pJR6fRYUxG+p/X/uxmQ2sqbsc9rIj0r+Cm8FL+c4BxJ/GgGW8UMuUFJvCr2T4jbHGLQg3rcAKn9PcMVrFzwHHvt8R3sBYH8Aa3m+3bsGbAcf5RxTe8x6fF+tGlSA3vcAlTuIaRgnsawsv4IDRa4hEhdV8Ks7vArEVM3UqXw7EJnOvRv4Et2oVmQbftZVxYlDr5ITxH2Zmku9E/OIkvHe1X8Di5okT0KgE/4nLL98+4mF5OOmJF/TR+N+Mp/89wVsSMzuOZkMo3ypGTjqICYVY4YZgrQUtSiozW8bYMIakpMjovlGXZU3QKOIdXZQhJTZHRurAYZU+R0WVhkmVyCt8PMaMrMSb8LZE9sVX3LvY24/14mF5OOmIzuqFHnCUxo2eEYv6JUPdmzV93FVJK61qRFAAAAABJRU5ErkJggg==) no-repeat 100%;
            display: inline-block;
            vertical-align: middle;
            width: 88px;
            height: 38px;
        }
        .info-wrap {
            width: auto;
            display: inline-block;
            vertical-align: text-top;
            padding: 10px;
            border-radius: 10px;
            background-color: #fff1c6;
            margin-bottom: 20px;
            .anchor-info {
                height: 255px;
                width: 268px;
                border: 1px solid #a56700;
                border-radius: 10px;
                .avatar {
                    display: block;
                    width: 116px;
                    height: 116px;
                    margin: 20px auto;
                    border: 5px solid #ffda8e;
                    border-radius: 100%;
                }
                .name {
                    margin-top: 6px;
                    color: #a56700;
                    font-size: 14px;
                    font-weight: 700;
                    text-align: center;
                }
                .room {
                    margin-top: 6px;
                    color: #a56700;
                    font-size: 14px;
                    font-weight: 700;
                    text-align: center;
                }
                .lable {
                    display: inline-block;
                    width: 80px;
                    font-weight: 400;
                }
            }
            .anchor-room {
                display: inline-block;
                .tips {
                    text-align: center;
                }
                .tips-title {
                    color: #a56700;
                    font-size: 14px;
                    font-weight: 700;
                }
                .tips-title:before {
                    width: 18px;
                    height: 18px;
                    display: inline-block;
                    margin-right: 5px;
                    content: "!";
                    background: red;
                    border-radius: 50%;
                    color: #fff;
                }
                .tips-title2 {
                    color: #a56700;
                    font-size: 14px;
                    font-weight: 700;
                }
                .tips-txt {
                    color: #664103;
                    font-size: 12px;
                    word-wrap: break-word;
                    display: inline-block;
                    width: 228px;
                }
            }
            .sign-info {
                box-sizing: border-box;
                -webkit-box-sizing: border-box;
                -moz-box-sizing: border-box;
                width: 490px;
                min-height: 255px;
                border: 1px solid #a56700;
                border-radius: 10px;
                background: #fff8e3;
                padding: 0 20px;
                .sign-info-title {
                    color: #664103;
                    font-size: 16px;
                    margin-top: 15px;
                    text-align: left;
                }
                .guild-desc {
                    padding-top: 5px;
                    padding-bottom: 5px;
                    .guild-desc-row {
                        margin-top: 5px;
                        font-size: 14px;
                        color: #a66700;
                        text-align: left;
                        word-break: break-all;
                        .desc-name {
                            color: #a56700;
                            font-weight: 600;
                        }
                    }
                }
                .guild-sign {
                    border-bottom: 1px solid #f2e3c1;
                    .guild-avatar {
                        display: block;
                        width: 64px;
                        height: 64px;
                        margin-top: 15px;
                        float: left;
                        border-radius: 100%;
                    }
                    .guild-sign-info {
                        margin-left: 64px;
                        padding-left: 10px;
                        padding-top: 15px;
                        .sign-info-row {
                            text-align: left;
                            font-size: 16px;
                            height: 30px;
                            line-height: 30px;
                            .opt-name {
                                color: #a66700;
                                font-size: 14px;
                                text-align: left;
                                min-width: 101px;
                            }
                            .opt-desc {
                                color: #664103;
                                font-weight: 600;
                                font-size: 14px;
                                min-width: 80px;
                            }
                            .opt-desc>.sign-guild-name {
                                display: block;
                                min-width: 60px;
                                max-width: 120px;
                                cursor: pointer;
                                white-space: nowrap;
                                text-overflow: ellipsis;
                                overflow: hidden;
                            }
                        }
                    }
                }
            }
        }
        .mr-20 {
            margin-right: 20px;
        }
        .rowwrap {
            width: 480px;
            margin: 0 auto;
        }
        .protocal-wrap {
            margin-top: 10px;
            text-align: center;
            .protocal-text {
                display: inline-block;
                vertical-align: middle;
                font-size: 14px;
            }
            #protocol {
                width: 0;
                visibility: hidden;
            }
            a {
                font-size: 14px;
                color: #f70;
                text-decoration: underline;
            }
            #protocol+label>i {
                display: inline-block;
                vertical-align: middle;
                width: 21px;
                height: 21px;
                background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABUAAAAVCAYAAACpF6WWAAAB+UlEQVQ4jaXUu49McRjG8c+5zG3nSkQkEolSyV+g0ZGlUOjoxC3ZiOiVIhQoRYNCQigURCMaUYmGRCUKIbF2ZnZ2Zvfs2aNYR46xd0/3e573903eN3nf4PPz0zaoMkKM1isM18g6OIMX+IZ5DPEDT3AStY1CA5zFJ9zGIews5Nsxibv4iOPrQWu4j1vYsUYXufbgIa4hWgka4A5ObAA2rou4sRL0whaBuc7jaBHawZX/AOa6jjj+/TiF1lYoaZrq9QfIbOu09+JIDp3cCjBJEr3+QJZlarVqbk/m0P2bBQ5H8waDOdCoT6hWK3l0IMaETbY+O5gzGs0LgkCr2VAqxcV4V4ys6Ez/7P4uroui6C/YUpbp92clyaIoirRaDVH4z/4MQ8urN507lXJZmqZmun1JkvypTNNUd6YnSRaVyyWddnMlIHzN3be5U6/XNOoTsizT7c0ajuYtLCRmun3p0pJararVbAiCYLXpvMuhj4tutVrRbjUFQWAwmNPrz8qyTLNRV59Y8YYU9SiH3sP3YlIqxTqdljiOhGGo026qVMrrAd/jZQ4dYmq8IgpDnXbL9m1tcRyPx+NKcQ5ZcdIPFI7CFjSF1/x7+i7h5iZhS7hc/DcOTS1fq6P4sAHgGxzE1aK52qCe4hkO4xj2YTdK+GK5zSd4ZWx54Bek84uVP667eAAAAABJRU5ErkJggg==) no-repeat;
            }
            #protocol+label.checked>i {
                background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABUAAAAVCAYAAACpF6WWAAAB6UlEQVQ4jaXUS0hUcRTH8c+Mk+CDkPIRBIHRA2tTLtoYPTaujLHHpkLIhRRZQk+3bouohdFCaBFWi0xzkRt35mZw0aISiSLLFiKhRFCaNNriemtmGnWcfqt7z/mf7z3/wz2/yGJ7RI4qRBRzqx2MrpArw3kMYgo/MYtp9OMMirIVRrJ0GlmCdaB8laYmcBU9K3VahEe4mwMQtuAJbqEgGzSC+ziZAyxTV3AnG7QtT2Coi2jk70zL8Anr/wMK49gRdtqcN7BiJ5dHuf4eqnEkhMbzAm6vpzVBZQ2jz8JoPLb0sHfNwLo2Gm6zkKTvHCNdYaY2hmKpV49EWVxYHlZQSLyTfS38mKb7OOMvUk9simExraj9A/Pf6T7Gl7fpwJJyTvew9SBTb3gQZ2Y887OzUcHqzfwJvX4azKg1EcwsVNVuLowEwLHn3KvLBoTJgo79ETiMbeDdIN8m2RWntom5r5RW0jxAaRVDN+g7y69lfWUg/E9b0JWWqj5AUy/FG4P35Dy9LbzsXg4Wqj6EFuEjKtPSG6pp6qOkgocnmEisBnyFPakudUpgJvkqKRjjcOruP5ZiCnnoEob51/quoXONsAW0p9ZlQpMCt2rEWA7ABA7hZmowm/OHiqEBR1GDzViHz4Jr9mNI5vLgNzADecxL7EjuAAAAAElFTkSuQmCC) no-repeat;
            }
        }
        .foot-wrap {
            margin-bottom: 20px;
        }
        .foot-tips {
            padding-bottom: 40px;
            text-align: center;
            font-size: 14px;
            color: #996700;
        }
        .disableButton {
            background-color: rgb(238, 241, 246);
            color: rgb(191, 203, 217);
            border-color: rgb(209, 219, 229);
        }
        .enableButton {
            background-color: #f75853;
            border-color:  #f75853;;
            color: white
        }
    }
  }
</style>


// WEBPACK FOOTER //
// Invite.vue?026ec2a9